import type {UnserializedFilterObject, FilterObject} from './types';
import {serializeFilterObject} from './serialize-filter-object';

// Attempting a comprehensive list of field types,
// this might not be exhaustive, however.

export type FilterFieldType =
    | 'string'
    | 'email'
    | 'currency'
    | 'number'
    | 'integer'
    | 'rating'
    | 'customField'
    | 'text'
    | 'phone'
    | 'relationship'
    | 'enum'
    | 'stage'
    | 'date-time'
    | 'location'
    | 'state'
    | 'map'
    | 'boolean'
    | 'date-time-nullable'
    | 'linked-lead-date';

export function serialize(
    filter: UnserializedFilterObject<any>,
    type: FilterFieldType
): FilterObject {
    const filterName = Object.keys(filter)[0];
    // @ts-ignore
    const filterValue = serializeFilterObject(filter[filterName], type);

    // @ts-ignore
    return {[filterName]: filterValue};
}
